import React from 'react';
import { OnboardingStep7Title } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep7/OnboardingStep7Title/OnboardingStep7Title';
import { OnboardingStep7Footer } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep7/OnboardingStep7Footer/OnboardingStep7Footer';
import { OnboardingStep6Body } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep7/OnboardingStep6Body/OnboardingStep6Body';

const OnboardingStep7 = () => {
  return (
    <div
      className={'flex flex-col gap-16 w-full h-full items-center justify-between overflow-y-auto'}
    >
      <OnboardingStep7Title />
      <OnboardingStep6Body />
      <OnboardingStep7Footer />
    </div>
  );
};

export default OnboardingStep7;
